import { cn } from '../../lib/utils'
import type { Status } from './types'

export interface StatusDotProps extends React.HTMLAttributes<HTMLSpanElement> {
  status?: Status
}

export function StatusDot({ status = 'idle', className, ...rest }: StatusDotProps) {
  return (
    <span
      role="status"
      aria-label={`status-${status}`}
      data-st={status}
      className={cn(
        'inline-block size-2 shrink-0 rounded-full',
        status === 'run' && 'bg-st-run shadow-[0_0_0_3px_var(--st-run-bg)]',
        status === 'warn' && 'bg-st-warn shadow-[0_0_0_3px_var(--st-warn-bg)]',
        status === 'down' &&
          'bg-st-down shadow-[0_0_0_3px_var(--st-down-bg)] [animation:status-pulse_1.4s_ease-in-out_infinite]',
        status === 'idle' && 'bg-st-idle',
        status === 'info' && 'bg-st-info',
        className
      )}
      {...rest}
    />
  )
}
